import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export const FacePensiveIcon: React.FC<IconProps> = ({ width = 32, height = 32, style }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="#FFB02E"
      />
      <path
        d="M9.99994 21.5V18.4393C9.99994 17.6444 9.35554 17 8.56062 17C7.71987 17 7.05542 17.7181 7.04316 18.5588C7.02329 19.9202 6.8351 21.7216 5.99995 22C2.99985 23 1.99999 27.5 4.49994 29.5C6.5 31.1001 8.49994 31 9.99994 31H12.7639C13.4465 31 13.9999 30.4466 13.9999 29.7639C13.9999 29.2957 13.7354 28.8677 13.3167 28.6584L12.9999 28.5H13.7192C14.1781 28.5 14.5781 28.1877 14.6894 27.7425L14.7574 27.4701C14.8806 26.9774 14.5079 26.5 13.9999 26.5L14.3291 26.3354C14.7402 26.1298 14.9999 25.7096 14.9999 25.25C14.9999 24.7904 14.7402 24.3702 14.3291 24.1646L13.9999 24H15.7499C16.4403 24 16.9999 23.4404 16.9999 22.75C16.9999 22.0596 16.4403 21.5 15.7499 21.5H9.99994Z"
        fill="#FFB02E"
      />
      <path
        d="M10.4191 16.2244C12.742 16.2244 14.6251 14.3414 14.6251 12.0185C14.6251 9.69557 12.742 7.8125 10.4191 7.8125C8.09621 7.8125 6.21313 9.69557 6.21313 12.0185C6.21313 14.3414 8.09621 16.2244 10.4191 16.2244Z"
        fill="white"
      />
      <path
        d="M21.5683 16.3011C23.9123 16.3011 25.8126 14.4009 25.8126 12.0568C25.8126 9.71274 23.9123 7.8125 21.5683 7.8125C19.2242 7.8125 17.324 9.71274 17.324 12.0568C17.324 14.4009 19.2242 16.3011 21.5683 16.3011Z"
        fill="white"
      />
      <path
        d="M9.99994 21.5V18.4393C9.99994 17.6444 9.35554 17 8.56062 17C7.71987 17 7.05542 17.7181 7.04316 18.5588C7.02329 19.9202 6.8351 21.7216 5.99995 22C2.99985 23 1.99999 27.5 4.49994 29.5C6.5 31.1001 8.49994 31 9.99994 31H12.7639C13.4465 31 13.9999 30.4466 13.9999 29.7639C13.9999 29.2957 13.7354 28.8677 13.3167 28.6584L12.9999 28.5H13.7192C14.1781 28.5 14.5781 28.1877 14.6894 27.7425L14.7574 27.4701C14.8806 26.9774 14.5079 26.5 13.9999 26.5L14.3291 26.3354C14.7402 26.1298 14.9999 25.7096 14.9999 25.25C14.9999 24.7904 14.7402 24.3702 14.3291 24.1646L13.9999 24H15.7499C16.4403 24 16.9999 23.4404 16.9999 22.75C16.9999 22.0596 16.4403 21.5 15.7499 21.5H9.99994Z"
        fill="#FF822D"
      />
      <path
        d="M7.14645 4.14645C7.54338 3.74951 8.63008 3 10 3C11.3699 3 12.4566 3.74951 12.8536 4.14645C13.0488 4.34171 13.0488 4.65829 12.8536 4.85355C12.6583 5.04882 12.3417 5.04882 12.1464 4.85355C11.8767 4.58382 11.0301 4 10 4C8.96992 4 8.12329 4.58382 7.85355 4.85355C7.65829 5.04882 7.34171 5.04882 7.14645 4.85355C6.95118 4.65829 6.95118 4.34171 7.14645 4.14645Z"
        fill="#402A32"
      />
      <path
        d="M18.1799 8.11589C18.6506 7.72368 19.9203 7 21.5 7C23.0797 7 24.3494 7.72368 24.8201 8.11589C25.0322 8.29267 25.0609 8.60795 24.8841 8.82009C24.7073 9.03223 24.392 9.06089 24.1799 8.88411C23.8506 8.60966 22.8003 8 21.5 8C20.1997 8 19.1494 8.60966 18.8201 8.88411C18.608 9.06089 18.2927 9.03223 18.1159 8.82009C17.9391 8.60795 17.9678 8.29267 18.1799 8.11589Z"
        fill="#402A32"
      />
      <path
        d="M13.7071 19.7071C14.062 19.3522 14.9113 18.7857 16.0815 18.9857C17.302 19.1944 17.8123 19.8165 18.093 20.4211C18.3256 20.922 18.9202 21.1396 19.4211 20.907C19.922 20.6744 20.1396 20.0798 19.907 19.5789C19.3924 18.4706 18.3815 17.3499 16.4185 17.0143C14.4052 16.6701 12.938 17.6478 12.2929 18.2929C11.9024 18.6834 11.9024 19.3166 12.2929 19.7071C12.6834 20.0976 13.3166 20.0976 13.7071 19.7071Z"
        fill="#402A32"
      />
      <path
        d="M12 11.5C12 12.6046 11.1046 13.5 10 13.5C8.89543 13.5 8 12.6046 8 11.5C8 10.3954 8.89543 9.5 10 9.5C11.1046 9.5 12 10.3954 12 11.5Z"
        fill="#402A32"
      />
      <path
        d="M23 11.5C23 12.6046 22.1046 13.5 21 13.5C19.8954 13.5 19 12.6046 19 11.5C19 10.3954 19.8954 9.5 21 9.5C22.1046 9.5 23 10.3954 23 11.5Z"
        fill="#402A32"
      />
    </svg>
  );
};
